module.exports = __webpack_public_path__ + "static/media/joinedTournaments_40_50.8c49f10c.png";